import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]" data-testid="auth-loading">
        <div
          className="w-10 h-10 border-2 rounded-full animate-spin"
          style={{ borderColor: "#0B3C5D", borderTopColor: "transparent" }}
        />
      </div>
    );
  }
  if (!user) {
    // Preserve the full path (incl. search + hash) so we land back here after login
    const fullPath = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to="/login" state={{ from: fullPath }} replace />;
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
